import { MDBBadge, MDBBtn, MDBIcon, MDBTable } from "mdbreact";
import { GenericProducts } from "../../../../constants";
import { lineName, unitLabel } from "./common";

/**
 * Items of an approved P.O. to receive: approved | received (less or more) | variant.
 * Denied items (approved 0) are not delivered, so they are not listed.
 */
export default function ReceiveTable({
  order,
  stock,
  receiveQtyOf,
  setReceiveQty,
  freeQtyOf,
  setFreeQty,
  onReceive,
  isLoading,
}) {
  const items = order.items.filter(({ qnty }) => qnty.approved !== 0);

  const short = items.filter(
    (item) => Number(receiveQtyOf(item)) < (item.qnty.approved ?? 0),
  ).length;

  return (
    <>
      <MDBTable small className="mb-0">
        <thead>
          <tr className="small text-muted">
            <th>Item</th>
            <th className="text-center" style={{ width: 90 }}>
              Approved
            </th>
            <th className="text-center" style={{ width: 110 }}>
              Received
            </th>
            <th
              className="text-center"
              style={{ width: 90 }}
              title="Free items given by the supplier, e.g. 6+1"
            >
              Free
            </th>
            <th style={{ width: 170 }}>Variant</th>
            <th className="text-center" style={{ width: 80 }}>
              On hand
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const generic = GenericProducts.find(item.pgid);
            const approved = item.qnty.approved ?? item.qnty.request;
            const qty = receiveQtyOf(item);
            const diff = (Number(qty) || 0) - approved;
            const onHand =
              stock[`${item.productId?._id}:${item.variant || ""}`]?.onHand ||
              0;
            return (
              <tr key={item._id}>
                <td className="align-middle">
                  {generic && (
                    <code className="mr-1">{generic.abbreviation}</code>
                  )}
                  {lineName(item)}
                  {item.productId?.tracksLot && (
                    <MDBBadge
                      color="info"
                      className="ml-1"
                      title="Lot number and expiry are entered upon receiving"
                    >
                      lot &amp; expiry
                    </MDBBadge>
                  )}
                </td>
                <td className="align-middle text-center font-weight-bold">
                  {approved}
                </td>
                <td className="align-middle">
                  <input
                    type="number"
                    min={0}
                    className="form-control form-control-sm text-center mx-auto px-1"
                    style={{ width: 80 }}
                    value={qty}
                    onChange={({ target }) =>
                      setReceiveQty(item._id, target.value)
                    }
                  />
                  {diff !== 0 && (
                    <small
                      className={`d-block text-center ${
                        diff < 0 ? "text-danger" : "text-primary"
                      }`}
                    >
                      {diff < 0 ? `${-diff} short` : `${diff} more`}
                    </small>
                  )}
                </td>
                <td className="align-middle text-center">
                  <input
                    type="number"
                    min={0}
                    className="form-control form-control-sm text-center mx-auto px-1"
                    style={{ width: 64 }}
                    value={freeQtyOf(item)}
                    title="Free items (same unit), e.g. 1 for 6+1"
                    onChange={({ target }) =>
                      setFreeQty(item._id, target.value)
                    }
                  />
                  {Number(freeQtyOf(item)) > 0 && (
                    <small className="d-block text-success">
                      {Number(qty) || 0}+{Number(freeQtyOf(item))}
                    </small>
                  )}
                </td>
                <td className="align-middle small text-muted">
                  {unitLabel(item)}
                </td>
                <td className="align-middle text-center">
                  <MDBBadge color={onHand > 0 ? "success" : "light"}>
                    {onHand}
                  </MDBBadge>
                </td>
              </tr>
            );
          })}
        </tbody>
      </MDBTable>
      <div className="px-3 py-2 border-top d-flex flex-wrap align-items-center justify-content-end grey lighten-5">
        <small className="mr-auto text-muted">
          {items.length} item(s) to receive
          {short > 0 && (
            <span className="text-danger ml-2">· {short} short</span>
          )}
        </small>
        <MDBBtn
          size="sm"
          color="primary"
          className="my-0 mr-0"
          disabled={isLoading || !items.length}
          onClick={onReceive}
        >
          <MDBIcon icon="box-open" className="mr-1" /> Receive &amp; add to
          stock
        </MDBBtn>
      </div>
    </>
  );
}
